module.exports = __webpack_public_path__ + "img/dzsw.9d8b34c4.webp";